import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { typeService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import { BaseEntity } from 'shared/types/general';
import toast from 'shared/utils/toast';
import TypeForm from '../components/TypeForm';

export const EditType = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.type.edit';

  const { typeId } = useParams();
  const dispatch = useAppDispatch();

  const [type, setType] = useState<BaseEntity>();

  useEffect(() => {
    typeService.get(+typeId).then(setType);
  }, []);

  const updateType = async (values) => {
    dispatch(loadingActions.startLoading());
    typeService.update(type.id, values).then((res) => {
      toast.crud.successUpdate('Tipo');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={type?.code}>
      <TypeForm type={type} onSubmit={updateType} />
    </TenantPage>
  );
};

export default EditType;
